import { a as R } from "./chunk-BaseElement-CJM6sCUz.js";
import { p as w } from "./chunk-productCompareStorage-CP1RJJhy.js";
import { W as A } from "./chunk-WithApiClient-Da1nY1F5.js";
import { h as H } from "./chunk-task-Cm4nHG2L.js";
import { T as E, x as i } from "./chunk-lit-element-D3OkYgeM.js";
import { n as k } from "./chunk-property---aaewZr.js";
import { e as _ } from "./chunk-query-DDwcON_0.js";
import { e as M, i as B, t as z } from "./chunk-directive-Bp3n1gab.js";
import { p as S, v as y, r as v, M as $, m as O } from "./chunk-directive-helpers-CP-KqGKM.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const P = (s, e, t) => {
  const r = /* @__PURE__ */ new Map();
  for (let a = e; a <= t; a++) r.set(s[a], a);
  return r;
}, x = M(class extends B {
  constructor(s) {
    if (super(s), s.type !== z.CHILD) throw Error("repeat() can only be used in text expressions");
  }
  dt(s, e, t) {
    let r;
    t === void 0 ? t = e : e !== void 0 && (r = e);
    const a = [], l = [];
    let o = 0;
    for (const p of s) a[o] = r ? r(p, o) : o, l[o] = t(p, o), o++;
    return { values: l, keys: a };
  }
  render(s, e, t) {
    return this.dt(s, e, t).values;
  }
  update(s, [e, t, r]) {
    const a = S(s), { values: l, keys: o } = this.dt(e, t, r);
    if (!Array.isArray(a)) return this.ut = o, l;
    const p = this.ut ?? (this.ut = []), m = [];
    let g, T, n = 0, u = a.length - 1, c = 0, d = l.length - 1;
    for (; n <= u && c <= d; ) if (a[n] === null) n++;
    else if (a[u] === null) u--;
    else if (p[n] === o[c]) m[c] = y(a[n], l[c]), n++, c++;
    else if (p[u] === o[d]) m[d] = y(a[u], l[d]), u--, d--;
    else if (p[n] === o[d]) m[d] = y(a[n], l[d]), v(s, m[d + 1], a[n]), n++, d--;
    else if (p[u] === o[c]) m[c] = y(a[u], l[c]), v(s, a[n], a[u]), u--, c++;
    else if (g === void 0 && (g = P(o, c, d), T = P(p, n, u)), g.has(p[n])) if (g.has(p[u])) {
      const f = T.get(o[c]), C = f !== void 0 ? a[f] : null;
      if (C === null) {
        const D = v(s, a[n]);
        y(D, l[c]), m[c] = D;
      } else m[c] = y(C, l[c]), v(s, a[n], C), a[f] = null;
      c++;
    } else $(a[u]), u--;
    else $(a[n]), n++;
    for (; c <= d; ) {
      const f = v(s, m[d + 1]);
      y(f, l[c]), m[c++] = f;
    }
    for (; n <= u; ) {
      const f = a[n++];
      f !== null && $(f);
    }
    return this.ut = o, O(s, m), E;
  }
});
var U = Object.defineProperty, b = (s, e, t, r) => {
  for (var a = void 0, l = s.length - 1, o; l >= 0; l--)
    (o = s[l]) && (a = o(e, t, a) || a);
  return a && U(e, t, a), a;
};
const F = `#graphql
  query getProductByHandle($handle: String!) {
    product(handle: $handle) {
      id
      title
      featuredImage {
        url
      }
      description
      vendor
      availableForSale
      variants(first: 1) {
        nodes {
          sku
        }
      }
      family: metafield(namespace:"custom", key:"family") {
        value
      }
      reference: metafield(namespace:"custom", key:"reference") {
        value
      }
      year: metafield(namespace:"custom", key:"year") {
        value
      }
      bandColor: metafield(namespace:"shopify", key:"band-color") {
        references(first: 10) {
          nodes {
            ...on Metaobject {
              field(key:"label") {
                value
              }
            }
          }
        }
      }
      caseColor: metafield(namespace:"shopify", key:"case-color") {
        references(first: 10) {
          nodes {
            ...on Metaobject {
              field(key:"label") {
                value
              }
            }
          }
        }
      }
      dialColor: metafield(namespace:"shopify", key:"dial-color") {
        references(first: 10) {
          nodes {
            ...on Metaobject {
              field(key:"label") {
                value
              }
            }
          }
        }
      }
      bezelColor: metafield(namespace:"custom", key:"bezel_color") {
        value
      }
      functions: metafield(namespace:"custom", key:"functions") {
        value
      }
      waterResistance: metafield(namespace:"custom", key:"water_resistance") {
        value
      }
      watchGlass: metafield(namespace:"custom", key:"watch_glass") {
        value
      }
      watchFeatures: metafield(namespace:"shopify", key:"watch-features") {
        references(first: 10) {
          nodes {
            ...on Metaobject {
              field(key:"label") {
                value
              }
            }
          }
        }
      }
      powerReserve: metafield(namespace:"custom", key:"power_reserve") {
        value
      }
      movement: metafield(namespace:"custom", key:"movement") {
        value
      }
      bezelMaterial: metafield(namespace:"custom", key:"bezel_material") {
        value
      }
      bracelet: metafield(namespace:"custom", key:"bracelet") {
        value
      }
      braceletType: metafield(namespace:"custom", key:"bracelet_type") {
        value
      }
      braceletMaterial: metafield(namespace:"custom", key:"bracelet_material") {
        value
      }
      caseSize: metafield(namespace:"custom", key:"case_size") {
        value
      }
      caseShape: metafield(namespace:"custom", key:"case_shape") {
        value
      }
      caseMaterial: metafield(namespace:"custom", key:"case_material") {
        value
      }
      caseDepth: metafield(namespace:"custom", key:"case_depth") {
        value
      }
      dialTexture: metafield(namespace:"custom", key:"dial_texture") {
        value
      }
      dialMarkers: metafield(namespace:"custom", key:"dial_markers") {
        value
      }
      priceRange {
        maxVariantPrice {
          amount
        }
      }
    }
  }
`;
class h extends A(
  R
) {
  constructor() {
    super(), this.productHandles = w.list().reverse(), this.productData = [], this.PRODUCT_CACHE = {}, this._productTask = new H(this, {
      task: async ([e]) => {
        await Promise.all(
          e.map(async (t) => {
            if (Object.hasOwn(this.PRODUCT_CACHE, t) || this.PRODUCT_CACHE[t]) return;
            const { product: r } = await this.$api.client.storefront({
              body: {
                query: F,
                variables: {
                  handle: t
                }
              }
            });
            if (!r)
              throw new Error("No product data found");
            this.PRODUCT_CACHE[t] = r, this.PRODUCT_CACHE[t].variants.nodes.length && (this.PRODUCT_CACHE[t].defaultVariant = this.PRODUCT_CACHE[t].variants.nodes[0]);
          })
        );
      },
      args: () => [this.productHandles]
    }), this.fullscreen = !1, this.open = !1, this.tableRows = [
      {
        label: "Price",
        key: "priceRange.maxVariantPrice.amount",
        format: (e) => Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          // @ts-ignore
          trailingZeroDisplay: "stripIfInteger"
        }).format(Number(e))
      },
      { label: "Brand", key: "vendor" },
      { label: "Family", key: "family.value" },
      { label: "SKU", key: "defaultVariant.sku" },
      { header: "Specifications" },
      { label: "Reference", key: "reference.value" },
      { label: "Year", key: "year.value" },
      {
        label: "Band Color",
        key: "bandColor.references.nodes",
        format: this.formatReferences
      },
      {
        label: "Case Color",
        key: "caseColor.references.nodes",
        format: this.formatReferences
      },
      {
        label: "Dial Color",
        key: "dialColor.references.nodes",
        format: this.formatReferences
      },
      { label: "Bezel Color", key: "bezelColor.value" },
      { label: "Functions", key: "functions.value" },
      { label: "Water Resistance", key: "waterResistance.value" },
      { label: "Glass", key: "watchGlass.value" },
      {
        label: "Features",
        key: "watchFeatures.references.nodes",
        format: this.formatReferences
      },
      { label: "Power Reserve", key: "powerReserve.value" },
      { label: "Movement", key: "movement.value" },
      { label: "Bezel Material", key: "bezelMaterial.value" },
      { label: "Bracelet", key: "bracelet.value" },
      { label: "Bracelet Type", key: "braceletType.value" },
      { label: "Bracelet Material", key: "braceletMaterial.value" },
      { label: "Case Size", key: "caseSize.value" },
      { label: "Case Shape", key: "caseShape.value" },
      { label: "Case Material", key: "caseMaterial.value" },
      { label: "Case Depth", key: "caseDepth.value" },
      { label: "Dial Texture", key: "dialTexture.value" },
      { label: "Dial Markers", key: "dialMarkers.value" }
    ], window.addEventListener("storage", (e) => {
      e.key === "product-compare" && (this.productHandles = w.list().reverse(), this.requestUpdate(), this.performUpdate());
    }), this.addEventListener("keydown", (e) => {
      e.key == "Escape" && this._closeFullscreen();
    });
  }
  update(e) {
    var t;
    e.has("productHandles") && ((t = this.drawer) == null ? void 0 : t.open) == !1 && (this.drawer.open = !0), super.update(e);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", (e) => {
      (e.target === this || e.target === this.outer) && this._closeFullscreen();
    });
  }
  get isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }
  _removeProduct(e) {
    const t = e.currentTarget, r = t == null ? void 0 : t.getAttribute("data-handle");
    r && w.remove(r);
  }
  _clearAll() {
    w.clear(), this._closeFullscreen();
  }
  _fullscreen() {
    var e;
    (e = this.tableDialog) == null || e.show(), this.drawer.open = !0, this.fullscreen = !0;
  }
  _closeFullscreen() {
    var e;
    (e = this.tableDialog) == null || e.close(), this.fullscreen = !1, this.drawer.open = !1;
  }
  _handleToggle() {
    this.drawer && (this.open = this.drawer.open, !this.drawer.open && this.fullscreen === !0 && this._closeFullscreen(), this.isMobile && this.drawer.open && this.fullscreen === !1 && this._fullscreen());
  }
  removeButton(e) {
    return i`
      <button
        data-handle="${e}"
        @click="${this._removeProduct}"
        class="btn btn--close absolute top-2 right-2 z-10"
      >
        <span class="sr-only">Remove Product</span>
        <svg-icon src="icon-close" class="size-3"></svg-icon>
      </button>
    `;
  }
  removeLink(e) {
    return i`
      <button
        data-handle="${e}"
        @click="${this._removeProduct}"
        class="text-xs underline"
      >
        <span>Remove</span>
      </button>
    `;
  }
  clearButton() {
    return i`
      <button
        @click="${this._clearAll}"
        class="font-utility shrink-0 py-1 text-sm underline"
      >
        Clear All
      </button>
    `;
  }
  fullscreenButton() {
    return i`
      <button
        @click="${this._fullscreen}"
        class="btn btn--primary ${this.fullscreen ? "hidden" : ""} h-10! min-w-16"
      >
        Compare
      </button>
    `;
  }
  closeFullscreenButton() {
    return i`
      <button
        @click="${this._closeFullscreen}"
        class="btn btn--close ${!this.fullscreen && "hidden"}"
      >
        <svg-icon src="icon-close" class="size-3"></svg-icon>
        <span class="sr-only">Close</span>
      </button>
    `;
  }
  _viewSpecs(e) {
    const t = e.currentTarget, r = t == null ? void 0 : t.getAttribute("data-handle");
    r && window.location.pathname.includes(r) && this._closeFullscreen();
  }
  specsButton(e) {
    return i`
      <a
        data-handle="${e}"
        @click="${this._viewSpecs}"
        href="/products/${e}#product-specs"
        class="font-utility text-sm underline"
      >
        View all specs
      </a>
    `;
  }
  renderCount() {
    return i`
      <span class="text-brand-dark"
        >(<span>${this.productHandles.length}</span>/3)</span
      >
    `;
  }
  renderImage(e, t) {
    var a;
    const r = (a = e == null ? void 0 : e.featuredImage) == null ? void 0 : a.url;
    return r ? i`
      <picture>
        <source
          media="(min-width: 969px)"
          srcset="${r}&width=417 1x, ${r}&width=834 2x"
        />
        <source
          media="(max-width: 968px)"
          srcset="${r}&width=198 1x, ${r}&width=396 2x"
        />
        <img
          class="${t}"
          src="${r}&width=198"
          loading="lazy"
          role="presentation"
        />
      </picture>
    ` : i``;
  }
  renderThumbnailImage(e, t) {
    var a;
    const r = (a = e == null ? void 0 : e.featuredImage) == null ? void 0 : a.url;
    return r ? i`
      <img
        class="${t}"
        src="${r}&width=160"
        loading="lazy"
        role="presentation"
      />
    ` : i``;
  }
  renderProducts() {
    return i`
      <ul
        class="-mx-4 flex grow snap-x snap-proximity gap-4 overflow-auto px-4 pt-1 pb-4"
      >
        ${x(
      this.productHandles,
      (e) => e,
      (e) => {
        var t;
        return i`
            <li
              class="relative flex w-80 shrink-0 snap-start scroll-ml-4 items-center rounded-xs border border-black/10 bg-white p-2"
            >
              <div class="body-text flex items-center gap-2.5">
                <div class="aspect-square h-20 w-20 shrink-0 grow-0">
                  ${this.renderThumbnailImage(
          this.PRODUCT_CACHE[e],
          "aspect-square h-20 w-20 object-cover"
        )}
                </div>
                <div>
                  <a
                    href="/products/${e}"
                    class="h7 line-clamp-2 leading-[1.2]"
                  >
                    ${(t = this.PRODUCT_CACHE[e]) == null ? void 0 : t.title}
                  </a>
                  ${this.removeLink(e)}
                </div>
              </div>
            </li>
          `;
      }
    )}
      </ul>
    `;
  }
  formatReferences(e) {
    return e.map((r) => {
      var a;
      return (a = r == null ? void 0 : r.field) == null ? void 0 : a.value;
    }).join(", ");
  }
  // Fetch product data based on each row's query
  renderProductData(e, t, r = (a) => a) {
    const a = t.split(".");
    let l = this.PRODUCT_CACHE[e];
    for (const o of a)
      l = l == null ? void 0 : l[o];
    return l !== void 0 ? r(l) : "N/A";
  }
  renderTable() {
    return i`
      <table style="--products-count: 3">
        <thead>
          <tr>
            <th scope="row">
              <span class="sr-only">Title</span>
            </th>
            ${x(
      this.productHandles,
      (e) => e,
      (e) => {
        var t;
        return i`
                <th scope="col" class="relative text-left">
                  ${this.removeButton(e)}
                  <a href="/products/${e}">
                    <div class="bg-brand-lighter aspect-square">
                      ${this.renderImage(
          this.PRODUCT_CACHE[e],
          "aspect-square w-full mix-blend-multiply object-cover"
        )}
                    </div>

                    <h3 class="h6 mt-3 mb-2 line-clamp-2 text-base md:text-lg">
                      ${(t = this.PRODUCT_CACHE[e]) == null ? void 0 : t.title}
                      <br /><br />
                    </h3>
                  </a>
                  <a
                    href="/products/${e}"
                    aria-hidden="true"
                    tab-index="-1"
                    class="btn btn--blur--inverted w-full"
                  >
                    Shop Now
                  </a>
                </th>
              `;
      }
    )}
          </tr>
        </thead>
        <tbody class="body-text text-base">
          ${this.tableRows.map(
      (e) => e.header ? i`
                  <tr>
                    <th scope="row" class="h6 text-left">${e.header}</th>
                  </tr>
                ` : i`
                  <tr>
                    <th scope="row" class="utility text-left">${e.label}</th>
                    ${x(
        this.productHandles,
        (t) => t,
        (t) => i`
                        <td class="utility text-right">
                          ${e.key ? this.renderProductData(
          t,
          e.key,
          e.format
        ) : ""}
                        </td>
                      `
      )}
                  </tr>
                `
    )}
          <tr>
            <th scope="row" class="utility border-b-transparent! text-left">
              <span class="sr-only"> View All Specs Links </span>
            </th>
            ${x(
      this.productHandles,
      (e) => e,
      (e) => i`
                <td class="border-b-transparent! text-right">
                  ${this.specsButton(e)}
                </td>
              `
    )}
          </tr>
        </tbody>
      </table>
    `;
  }
  render() {
    var e;
    return i`
      <div
        data-outer
        class="${this.productHandles.length ? "" : "hidden"} ${this.fullscreen ? "top-0 bg-black/50 px-safe-or-0 z-50" : "z-40 px-8"} md:px-safe-or-pagemargin md:py-safe-or-4 fixed right-0 bottom-0 left-0 transform-gpu pt-10 transition-all duration-300"
      >
        <div
          class="${this.fullscreen ? "bg-white max-w-6xl" : (e = this.drawer) != null && e.open ? "bg-white/85 max-w-5xl" : "bg-white/85 max-w-2xl"} shadow-custom mx-auto h-full transform-gpu overflow-y-auto rounded-t-xl backdrop-blur-md transition-all md:rounded-xs"
        >
          <details class="group/compare" @toggle="${this._handleToggle}">
            <summary
              tabindex="0"
              class="${this.fullscreen ? "p-4 bg-white" : "p-2 group-open/compare:px-4 group-open/compare:pt-4"} sticky top-0 z-30 flex w-full cursor-pointer items-center justify-between gap-2"
            >
              <div class="flex items-center gap-2">
                <svg-icon
                  src="icon-select-arrow"
                  class="size-3 rotate-180 group-open/compare:rotate-0"
                ></svg-icon>
                <span class="h5 text-base md:text-lg">
                  Compare
                  <span class="hidden md:inline">Products</span>
                  ${this.renderCount()}
                </span>
              </div>
              <div class="flex items-center gap-4">
                ${this.clearButton()} ${this.fullscreenButton()}
                ${this.closeFullscreenButton()}
              </div>
            </summary>
            <div>
              <div
                class="${this.fullscreen ? "hidden" : "flex"} flex-col gap-4 px-4 md:flex-row"
              >
                ${this.renderProducts()}
              </div>
              <dialog class="relative w-full bg-transparent px-4">
                <button
                  autofocus
                  @click="${this._closeFullscreen}"
                  class="sr-only"
                >
                  Close
                </button>
                ${this.renderTable()}
              </dialog>
            </div>
          </details>
        </div>
      </div>
    `;
  }
}
b([
  k({ type: Array })
], h.prototype, "productHandles");
b([
  k({ type: Array })
], h.prototype, "productData");
b([
  k({ type: Object })
], h.prototype, "PRODUCT_CACHE");
b([
  k({ type: Boolean, attribute: "data-fullscreen", reflect: !0 })
], h.prototype, "fullscreen");
b([
  k({ type: Boolean, attribute: "data-open", reflect: !0 })
], h.prototype, "open");
b([
  _("details")
], h.prototype, "drawer");
b([
  _("dialog")
], h.prototype, "tableDialog");
b([
  _("[data-outer]")
], h.prototype, "outer");
if (!customElements.get("product-compare")) {
  const s = document.querySelector("product-compare");
  s && s.remove(), document.querySelector("app-provider") && (document.body.insertAdjacentHTML(
    "beforeend",
    "<product-compare></product-compare>"
  ), customElements.define("product-compare", h), document.querySelectorAll("track-product-compare").forEach((t) => {
    typeof t.init == "function" && t.init();
  }));
}
export {
  h as ProductCompare
};
